"use client";

import React, { useContext } from 'react';
import Button from '../../button';
import { ModalContext } from '../context';
const NormalCancelBtn = () => {
  const _useContext = useContext(ModalContext),
    cancelButtonProps = _useContext.cancelButtonProps,
    cancelTextLocale = _useContext.cancelTextLocale,
    onCancel = _useContext.onCancel;
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelTextLocale);
};
export default NormalCancelBtn;